const getCardFromOffer = (cardId, offer) => {
  let matchedCard = null;
  if (offer.children.length > 0) {
    offer.children.forEach((section) => {
      if (section.children && section.children.length > 0) {
        section.children.forEach((card) => {
          if (card._id === cardId) {
            matchedCard = card;
          }
        });
      }
    });
  }
  return matchedCard;
};

export default getCardFromOffer;
